import { css } from 'lit';
import { DIALOG_DEFAULT_Z_INDEX } from './pimster-dialog.constants';

export const pimsterDialogStyle = css`
  --max-width: 748px;
  .wrapper {
    opacity: 0;
    transition:
      visibility 0s,
      opacity 0.25s ease-in;
    z-index: ${DIALOG_DEFAULT_Z_INDEX};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrapper:not(.open) {
    visibility: hidden;
    display: none;
  }

  .wrapper.open {
    position: fixed;
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100vh;
    z-index: ${DIALOG_DEFAULT_Z_INDEX};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    visibility: visible;
  }

  .overlay {
    background: rgba(0, 0, 0, 0.8);
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  iframe {
    border: none;
    height: 100%;
    width: 100%;
    border-radius: 1rem;
  }

  .dialog {
    position: fixed;
    max-width: var(--max-width);
    animation: scaleUp 0.3s ease-in-out;
  }

  @media (max-width: 748px) {
    .dialog {
      height: 100dvh;
      width: 100dvw;
      top: 0;
      left: 0;
    }

    iframe {
      border-radius: 0 !important;
    }
  }

  @media (min-width: 748px) {
    .dialog {
      aspect-ratio: 9 / 16;
      height: 90dvh;
    }
  }

  @keyframes scaleUp {
    0% {
      transform: scale(0.2);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
